import axios from "../axiosPlugin.js";

export const getStockReportService = data => {
  return axios({
    url: "/api/report/stockReport",
    method: "get",
    data: {
      data,
    },
  });
};

export const getLogListService = data => {
  return axios({
    url: "/api/group/listForLog",
    method: "get",
    data: {
      data,
    },
  });
};